import "core-js/modules/es6.regexp.split";

// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Not exported from index

/** @private */
var TextMessageFormat =
/** @class */
function () {
  function TextMessageFormat() {}

  TextMessageFormat.write = function (output) {
    return "" + output + TextMessageFormat.RecordSeparator;
  };

  TextMessageFormat.parse = function (input) {
    if (input[input.length - 1] !== TextMessageFormat.RecordSeparator) {
      throw new Error("Message is incomplete.");
    }

    var messages = input.split(TextMessageFormat.RecordSeparator);
    messages.pop();
    return messages;
  };

  TextMessageFormat.RecordSeparatorCode = 0x1e;
  TextMessageFormat.RecordSeparator = String.fromCharCode(TextMessageFormat.RecordSeparatorCode);
  return TextMessageFormat;
}();

export { TextMessageFormat };